(function ($) {


    // stx reorder 
    this.reorder = new function () {
        var self = this;
        console.log(this);

        this.pushQueue = function (i, data, el) {

            console.log(data[i]);
            console.log(data);
            console.log(el);
            //LOW STOCK -- add as many as possible if stock is below requested ammount
            if (data[i].check_inventory) {
                data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
            }




            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                data: {
                    quantity: data[i].quantity,
                    id: data[i].id
                },
                complete: function (res) {
                    if (i >= data.length - 1) {

                        //products from queue are now added to the cart -> stop loading signal and go to cart
                        el.removeClass('loading');
                        //       mini cart section render
                        fetch('/?sections=cart-drawer')
                            .then((response) => response.json())
                            .then((data) => {
                                console.log(data);
                                let SectionHtml = data['cart-drawer'];
                                document.getElementById("temp_cart").innerHTML = SectionHtml;
                                let IDminiCart = document.querySelector("#temp_cart #CartDrawer");
                                let drwIDminiCart = document.querySelector("cart-drawer #CartDrawer");
                                drwIDminiCart.innerHTML = IDminiCart.innerHTML;
                                document.querySelector("cart-drawer").classList.add('animate', 'active');
                                if (document.querySelector("cart-drawer").classList.contains('is-empty'))
                                    document.querySelector("cart-drawer").classList.remove('is-empty')
                            });
                        fetch('/cart.js')
                            .then((response) => response.json())
                            .then((cart) => {
                                var count = cart.item_count;
                                if(document.querySelector(".cart-count-bubble") == null ){
                                    document.querySelector("#cart-icon-bubble .small-hide.medium-hide").insertAdjacentHTML('afterEnd', `<div class="cart-count-bubble"><span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span></div>`)
                                }else{
                                    document.querySelector(".cart-count-bubble").innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
                                }
                                
                            });

                        console.log("notification off");
                        return;
                    } else {
                        self.pushQueue(i + 1, data, el);
                    }
                }
            });





        }

        this.listen = function () {
            var el = $(this);
            
            var ids = el.attr('data-variant-ids').split(',');
            var productTitle = el.attr('data-product-title').split(',');
            var quantities = el.attr('data-variant-quantities').split(',');
            var inventories = el.attr('data-variant-inventories').split(',');
            var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
            var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
            ids.splice(-1, 1);
            productTitle.splice(-1, 1);
            quantities.splice(-1, 1);
            inventories.splice(-1, 1);
            inventory_policies.splice(-1, 1);
            inventory_trackers.splice(-1, 1);

            var data = [];
            for (var i = 0; i < ids.length; i++) {
                data.push({
                    id: ids[i],
                    product_title: productTitle[i],
                    quantity: quantities[i],
                    inventory: inventories[i],
                    check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
                });
            }
            el.addClass('loading');
            self.pushQueue(0, data, el);
        }

        this.init = function () {
            $('.reorder-btn').on('click', self.listen);
        }
    }

    $(reorder.init);


})(jQuery)